export enum AnalyticsEventCategories {
    ClickedCountMeIn = 'clickedCountMeIn',
    Social = 'social',
    CloseSurvey = 'closeSurvey',
    SubmitSurvey = 'submitSurvey',
    Dashboard = 'dashboard',
    Authentication = 'authentication',
    MailingList = 'mailingList'
}
